import { Address } from '@app/models/Address';
import { ContactApi } from '@app/services/apiServices/ContactApi';
import { Property } from "@app/models/Property";
import { HomeownerApi } from "@app/services/apiServices/HomeownerApi";
import { PropertyApi } from "@app/services/apiServices/PropertyApi";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { ScrollService } from "@app/services/Scroll.service";
import { SpinnerService } from "@app/services/spinner.service";
import { UserStore } from "@app/services/stores/UserStore";
import { PropertyGroupApi } from "@app/services/apiServices/PropertyGroupApi";
import { PropertyGroupCandidate } from "@app/models/PropertyGroupCandidate";
import { ProductApi } from "@app/services/apiServices/ProductApi";
import { PropertyGroup } from "@app/models/PropertyGroup";
import { take } from "rxjs/operators";
import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { AppDataService } from "@app/services/appData.service";
import { RegistrationAltAddressNeedsCorrectionDialog } from "@app/pages/registration/registrationDialogAltAddressNeedsCorrection.component";
import { RegistrationAltAddressDialog } from "@app/pages/registration/registrationDialogAltAddress.component";
import { RegistrationNoPropertyDialog } from "@app/pages/registration/registrationDialogNoProperty.component";
import { RegistrationAltDetailsCouponDialog } from "@app/pages/registration/registrationAltDetailsCoupon.dialog";
import { RegistrationInvalidAddressDialog } from "@app/pages/registration/registrationDialogInvalidAddress.component";
import { OneButtonDialogComponent } from "@app/components/sharedDialogs/oneButtonDialog.component";
import { RegistrationStopHoldDialog } from "@app/pages/registration/registrationDialogStopHold.component";
import { DialogErrorDialog } from "@app/components/sharedDialogs/dialogError.dialog";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { ErrorHandlerService } from "@app/services/ErrorHandler.service";

@Component({
    selector: 'app-add-property',
    template: require('./addProperty.html')
})
export class AddPropertyComponent implements OnInit {
    property: Property = { address: {}, hoa: { pmc: {} } };
    couponOverride = false;
    uiViewName_BY_ADDRESS: string = 'byAddress';
    uiViewName_BY_IDS: string = 'byIds';
    uiSelectedViewName: string = this.uiViewName_BY_IDS;
    isLoadingFindMyProperty: boolean = false;
    disableInputsProperty: boolean = false;
    searched: boolean = false;
    invalidCheckVar: boolean = false;
    validationData: any;
    isCorrectingAddress: boolean = false;
    getWebUrl: () => string;
    multiRelationshipEnabled = false;
    groupCandidates: PropertyGroupCandidate[];
    availableGroups: PropertyGroup[];
    getPmcContactUrl = (pmcId: string) => this.getWebUrl() + `/guest/#/contact/?pmcId=${pmcId}`;
    $stateParams: any;
    setPropertyAddressSubject: Subject<void> = new Subject<void>();

    constructor(@Inject(AppDataService) private appDataService: AppDataService,
                @Inject(PropertyApi) private propertyApi: PropertyApi,
                @Inject(PropertyGroupApi) private propertyGroupApi: PropertyGroupApi,
                @Inject(HomeownerApi) private homeownerApi: HomeownerApi,
                @Inject(ContactApi) private ContactApi: ContactApi,
                @Inject(ProductApi) private productApi: ProductApi,
                @Inject(MatDialog) private dialog: MatDialog,
                @Inject(NetworkErrorService) private NetworkErrorService: NetworkErrorService,
                @Inject(ErrorHandlerService) private errorHandlerService: ErrorHandlerService,
                @Inject(SpinnerService) private SpinnerService: SpinnerService,
                @Inject(ScrollService) private ScrollService: ScrollService,
                @Inject(UserStore) private userStore: UserStore,
                @Inject(Router) private router: Router) {

        if(this.router.getCurrentNavigation()) {
            this.$stateParams = this.router.getCurrentNavigation().extras.state;
        }

    }

    ngOnInit() {
        this.getWebUrl = () => this.appDataService.appConfig.get_APP_ENV().HOAPASS_WEB_URL;
        if (this.$stateParams && this.$stateParams.property) {
            this.uiSelectedViewName = this.uiViewName_BY_IDS;
            this.property = this.$stateParams.property;
            this.defaultPropertyAddress().then(() => {}, () => {});
        }
    }

    defaultNickname() {
        if (this.property &&
            this.property.address &&
            this.property.address.line1 &&
            this.property.address.line1.length > 0 &&
            !this.searched) {

            if (this.multiRelationshipEnabled) {
                this.property = { ...this.property, nickname: this.property.address.line1 + ' - ' + this.property.hoa.couponId };
            } else {
                this.property = { ...this.property, nickname: this.property.address.line1 };
            }
        }
    }

    isCouponDataPresent() {
        return this.property && this.property.couponId &&
            this.property.couponId.toString().length > 0 &&
            this.property.hoa &&
            this.property.hoa.couponId &&
            this.property.hoa.couponId.toString().length > 0 &&
            this.property.hoa.pmc &&
            this.property.hoa.pmc.couponId &&
            this.property.hoa.pmc.couponId.toString().length > 0;

    }

    isAddressPresent() {
        return this.property && this.property.address
            && this.property.address.line1 && this.property.address.line1.toString().length > 0
            && this.property.address.city && this.property.address.city.toString().length > 0
            && this.property.address.state && this.property.address.state.toString().length > 0
            && this.property.address.postalCode && this.property.address.postalCode.toString().length > 0;

    }

    isAddressFieldValid(value) {
        return value && value.length > 0 && value.toLowerCase() !== 'null'
    }

    isAddressValid(address: Address) {
        return (this.isAddressFieldValid(address.line1) || this.isAddressFieldValid(address.addressLine1))
            && this.isAddressFieldValid(address.city)
            && this.isAddressFieldValid(address.state)
            && this.isAddressFieldValid(address.postalCode)
            && new RegExp('^[0-9]{5}$').test(address.postalCode);
    }

    startCorrectingAddress() {
        this.isCorrectingAddress = true;
    }

    stopCorrectingAddress() {
        this.isCorrectingAddress = false;
    }

    cleanAddress(address: Address) {
        if (address.postalCode !== null) {
            address.postalCode = address.postalCode.substr(0, 5);
        }
    }

    setPropertyAddress(address: Address) {
        this.cleanAddress(address);
        if (!this.isAddressValid(address)) {
            this.startCorrectingAddress();
        } else {
            this.stopCorrectingAddress();
        }

        this.property.address = address;
        this.setPropertyAddressSubject.next();
    }

    updateDefaultPropertyAddress() {
        this.stopCorrectingAddress();
        this.defaultPropertyAddress().then(() => {}, () => {});
    }

    defaultPropertyAddress(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (this.isCouponDataPresent()) {
                this.productApi.fetchProductOrganization(this.property.hoa.pmc.couponId, this.property.hoa.couponId)
                    .pipe(take(1)).subscribe((productResp) => {

                        let multiRelationshipProduct = productResp.products.find(product => product.productType === 'multi-relationship');
                        this.multiRelationshipEnabled = (multiRelationshipProduct != null && multiRelationshipProduct.productStatus === 'active');

                        this.propertyApi.propertyAddressGet(false, this.property.hoa.pmc.couponId, this.property.hoa.couponId, this.property.couponId)
                            .pipe(take(1)).subscribe((resp) => {
                                //todo until infrastructure fixes the propertyAddressGet call
                                resp.line1 = resp.addressLine1;
                                resp.line2 = resp.addressLine2;
                                if (resp.line1) {
                                    if (!this.isAddressPresent()) {
                                        this.setPropertyAddress(resp);
                                        this.defaultNickname();
                                        resolve();
                                    } else {
                                        if (this.property.address.line1 === resp.line1 &&
                                    (this.property.address.line2 === undefined || this.property.address.line2 === resp.line2) &&
                                    this.property.address.city === resp.city &&
                                    this.property.address.state === resp.state &&
                                    this.property.address.postalCode === resp.postalCode) {
                                            // DO NOTHING = things match
                                            resolve();
                                        } else {
                                            let propertyAddress = "Address Line 1: " + resp.line1 + "<br>";
                                            if (resp.line2)
                                                propertyAddress = propertyAddress + "Address Line 2: " + resp.line2 + "<br>";
                                            if (resp.unit)
                                                propertyAddress = propertyAddress + "Unit#: " + resp.unit + "<br>";
                                            propertyAddress = propertyAddress + "City: " + resp.city + "<br> State: " + resp.state + "<br>Postal Code: " + resp.postalCode;

                                            // Retrieve pmc details
                                            this.ContactApi.pmcOrganizationDetailsGET(
                                                true,
                                                this.property.hoa.pmc.couponId
                                            ).pipe(take(1)).subscribe((data) => {
                                                if (data == null) {
                                                    reject('No pmc found with Coupon ID: ' + this.property.hoa.pmc.couponId)
                                                    return
                                                }

                                                const pmcDataName = data.name;
                                                const pmcCouponId = this.property.hoa.pmc.couponId;

                                                let dialogRef;
                                                if (!this.isAddressValid(resp)) {
                                                    dialogRef = this.dialog.open(RegistrationAltAddressNeedsCorrectionDialog,{
                                                        data: {
                                                            propertyAddress: propertyAddress,
                                                            contactUrl: this.getPmcContactUrl(pmcCouponId),
                                                            pmcName: pmcDataName
                                                        }
                                                    });
                                                } else {
                                                    dialogRef = this.dialog.open(RegistrationAltAddressDialog, {
                                                        data: {
                                                            propertyAddress: propertyAddress,
                                                            contactUrl: this.getPmcContactUrl(pmcCouponId),
                                                            pmcName: pmcDataName
                                                        }
                                                    });
                                                }
                                                dialogRef.afterClosed().pipe(take(1)).subscribe((data) => {
                                                    if (data === 'A') {
                                                        this.setPropertyAddress(resp);
                                                        resolve();
                                                    } else {
                                                        reject();
                                                    }
                                                });
                                            });
                                        }
                                    }
                                } else {
                                    this.setPropertyAddressSubject.next();
                                    this.propertyApi.propertiesValidateGet(false, this.property.hoa.pmc.couponId, this.property.hoa.couponId, this.property.couponId)
                                        .pipe(take(1)).subscribe((resp) => {
                                            if (resp.valid === true && (resp.doNotProcess === false || resp.doNotProcessCode === "L01")) {
                                                resolve();
                                            } else if (resp.valid === true && resp.doNotProcess === true) {
                                                reject('STOPHOLD');
                                            } else {
                                                reject('Invalid property');
                                            }
                                        }, () => {
                                            //todo this should really be changed by the service to not be a regular 500 error,
                                            // so we can specifically catch the invalid property errors.
                                            reject('Invalid property');
                                        });
                                }
                            }, (err) => {
                                if (err.status === 404) {
                                    this.dialog.open(RegistrationNoPropertyDialog, {
                                        data: {
                                            pmcId: this.property.hoa.pmc.couponId,
                                        }
                                    });
                                    reject();
                                } else {
                                    this.NetworkErrorService.handleNetworkError(err, true)
                                        .pipe(take(1)).subscribe((resp) => {
                                            if (resp === true) {
                                                this.defaultPropertyAddress().then(() => {}, () => {});
                                            }
                                            reject();
                                        });
                                }
                            });
                    }, (productErr) => {
                        this.NetworkErrorService.handleNetworkError(productErr, true)
                            .pipe(take(1)).subscribe((resp) => {
                                if (resp === true) {
                                    this.defaultPropertyAddress().then(() => {}, () => {});
                                }
                                reject();
                            });
                    });
            } else {
                reject();
            }
        });
    }

    openDefaultCouponData() {
        if (this.isAddressPresent()) {
            this.defaultCouponData();
        }
    }

    defaultCouponData(): Promise<void> {
        return new Promise((resolve, reject) => {
            //if each of the required fields for address is defined then call api to retrieve coupon data
            if (this.isAddressPresent()) {
                this.propertyApi.couponGet(false, this.property.address)
                    .pipe(take(1)).subscribe((data) => {
                        if (data.hoaCouponId && data.pmcCouponId) {
                            if (!this.isCouponDataPresent()) {
                                if (this.property.hoa) {
                                    this.property.hoa.couponId = data.hoaCouponId;
                                } else {
                                    this.property.hoa = { couponId: data.hoaCouponId };
                                }
                                this.property.couponId = data.propertyCouponId;
                                if (this.property.hoa.pmc) {
                                    this.property.hoa.pmc.couponId = data.pmcCouponId;
                                } else {
                                    this.property.hoa.pmc = { couponId: data.pmcCouponId };
                                }

                                if (data.propertyCouponId === null && data.hoaCouponId === null && data.pmcCouponId === null) {
                                    this.disableInputsProperty = false;
                                    this.property.hoa.couponId = undefined;
                                    this.property.hoa.pmc.couponId = undefined;
                                    this.property.couponId = undefined;
                                }
                                resolve();
                            } else {
                                if (this.property.couponId === data.propertyCouponId &&
                                this.property.hoa.couponId === data.hoaCouponId &&
                                this.property.hoa.pmc.couponId === data.pmcCouponId) {
                                // DO NOTHING - Things match
                                    resolve();
                                } else {
                                    let dialogRef = this.dialog.open(RegistrationAltDetailsCouponDialog, {
                                        data: { resp: data }
                                    });
                                    dialogRef.afterClosed().pipe(take(1)).subscribe((response) => {
                                        if (response === 'A') {
                                            if (this.property.hoa) {
                                                this.property.hoa.couponId = data.hoaCouponId;
                                            } else {
                                                this.property.hoa = { couponId: data.hoaCouponId };
                                            }
                                            this.property.couponId = data.propertyCouponId;
                                            if (this.property.hoa.pmc) {
                                                this.property.hoa.pmc.couponId = data.pmcCouponId;
                                            } else {
                                                this.property.hoa.pmc = { couponId: data.pmcCouponId };
                                            }
                                            resolve();
                                        } else {
                                            reject();
                                        }
                                    });
                                }
                            }
                        } else {
                        //lets check for non val users
                            if (this.isCouponDataPresent()) {
                                this.propertyApi.propertiesValidateGet(false,
                                    this.property.hoa.pmc.couponId,
                                    this.property.hoa.couponId,
                                    this.property.couponId)
                                    .pipe(take(1)).subscribe((data) => {
                                        if (data.valid === true) {
                                            resolve();
                                        } else {
                                            reject('Invalid property');
                                        }
                                    });
                            } else {
                                reject();
                            }
                        }

                        return data;
                    }, (err) => {
                        this.disableInputsProperty = false;
                        this.NetworkErrorService.handleNetworkError(err, true)
                            .pipe(take(1)).subscribe((resp) => {
                                if (resp === true) {
                                    this.defaultCouponData().then(() => {}, () => {});
                                }
                                reject();
                            });
                    });
            } else {
                reject();
            }

        });
    }

    changeUiView(viewName: string) {

        this.searched = false;
        if (this.property) {
            this.property = {
                address: {
                    line1: undefined,
                    line2: undefined,
                    unit: undefined,
                    city: undefined,
                    state: undefined,
                    postalCode: undefined
                },
                nickname: undefined,
                couponId: undefined,
                hoa: {
                    couponId: undefined,
                    pmc: {
                        couponId: undefined
                    }
                }
            };
        }

        this.uiSelectedViewName = viewName;
        // reset to defaults
        this.isLoadingFindMyProperty = false;
        this.disableInputsProperty = false;
        if (this.uiSelectedViewName === this.uiViewName_BY_ADDRESS) {
            if (this.isCouponDataPresent()) {
                this.disableInputsProperty = true;
            }
        }
    }

    invalidCheck(addressError) {
        if (addressError.hasOwnProperty("searching")) {
            this.isLoadingFindMyProperty = addressError["searching"];
        }
        for (let key in addressError) {
            if (addressError[key]) {
                this.invalidCheckVar = true;
                return;
            }
        }
        this.invalidCheckVar = false;
    }

    findDisabled() {
        if (this.uiSelectedViewName === this.uiViewName_BY_ADDRESS) {
            return (this.invalidCheckVar || !(this.isAddressPresent() && (this.property && this.property.nickname)));
        } else {
            return !this.isCouponDataPresent() || this.invalidCheckVar;
        }
    }

    findMyProperty() {
        this.isLoadingFindMyProperty = true;
        this.disableInputsProperty = false;
        if (this.uiSelectedViewName === this.uiViewName_BY_ADDRESS) {
            this.searched = true;
            this.defaultCouponData().then(() => {
                this.isLoadingFindMyProperty = false;
                this.ScrollService.scrollTo('unableToFindPropertyAnchor');

                // if property was found (then we want to disable the remaining details))
                if (this.property &&
                    this.property.couponId &&
                    this.property.hoa &&
                    this.property.hoa.couponId &&
                    this.property.hoa.pmc &&
                    this.property.hoa.pmc.couponId) {

                    this.disableInputsProperty = true;
                    this.ScrollService.scrollTo('propertyIdFormAnchor');
                }
            }, () => {}).catch(() => {
                this.isLoadingFindMyProperty = false;
            });
        }
        else if (this.uiSelectedViewName === this.uiViewName_BY_IDS) {
            this.defaultPropertyAddress().then(() => {
                this.searched = true;
                this.isLoadingFindMyProperty = false;
                this.ScrollService.scrollTo('unableToFindAddressAnchor');
                if (this.property.address && this.property.address.line1) {
                    this.ScrollService.scrollTo('addressFormAnchor');
                }
            }, () => {}).catch(() => {
                this.dialog.open(RegistrationNoPropertyDialog, {
                    data: { pmcId: this.property.hoa.pmc.couponId }
                });
                this.isLoadingFindMyProperty = false;
            });
        }
    }

    submit() {
        this.SpinnerService.showSpinner();
        if (this.isCorrectingAddress) {
            //if correcting address we will skip calling
            //defaultPropertyAddress to match the
            //coupon ID address against what is entered
            //since it will always be different
            this.submitStep2();
        } else {
            this.defaultPropertyAddress().then(() => {
                this.submitStep2();
            }, (err) => {
                this.SpinnerService.closeSpinner();
                if (err === 'Invalid property') {
                    this.dialog.open(RegistrationNoPropertyDialog, {
                        data: { pmcId: this.property.hoa.pmc.couponId }
                    });
                }
            })
        }
    }

    submitStep2() {
        if (!this.isAddressValid(this.property.address)) {
            this.dialog.open(RegistrationInvalidAddressDialog);
            this.SpinnerService.closeSpinner();
        } else {
            let userId = this.userStore.getHoaHomeownerId();

            this.propertyApi.propertiesValidateGet(false,
                this.property.hoa.pmc.couponId,
                this.property.hoa.couponId,
                this.property.couponId)
                .pipe(take(1)).subscribe((resp) => {
                    this.validationData = resp;
                    if (resp.valid === true && (resp.doNotProcess === false || resp.doNotProcessCode === "L01")) {
                    //todo set nickname?
                        this.propertyApi.homeownersIdPropertiesPost(false, userId, this.property)
                            .pipe(take(1)).subscribe({ next: (response) => {
                                let property = response.body;
                                this.processMultiRelationship(property.id);
                            }, error: (err) =>{
                                if (err.error?.message === 'Property already registered. Cannot add the same property again' ) {
                                    this.dialog.open(OneButtonDialogComponent, {
                                        data: {
                                            buttonText: 'OK',
                                            header: 'Property Registration Error',
                                            message: 'The property you entered is already registered. Cannot add the property twice.'
                                        }
                                    });
                                    this.SpinnerService.closeSpinner();
                                } else {
                                    let errorMessage = err.error.message;
                                    if (err.error.errors && err.error.errors.length > 0) {
                                        err.error.errors.forEach(msg => {
                                            errorMessage += '<br><br>' + msg;
                                        })
                                    }
                                    this.errorHandlerService.handleNetworkError(err, true, errorMessage)
                                        .pipe().subscribe(() =>  {
                                            this.SpinnerService.closeSpinner()
                                        })
                                }
                            } })
                    } else if (resp.valid === true && resp.doNotProcess === true) {
                        this.SpinnerService.closeSpinner();
                        this.dialog.open(RegistrationStopHoldDialog, {
                            data: { reasonCode: resp.doNotProcessCode }
                        });
                    } else {
                        this.SpinnerService.closeSpinner();
                        if (resp.message === 'No matching record found.') {
                            this.dialog.open(RegistrationNoPropertyDialog, {
                                data: { pmcId: this.property.hoa.pmc.couponId }
                            });
                        } else {
                            this.dialog.open(RegistrationStopHoldDialog, {
                                data: { reasonCode: resp.doNotProcessCode }
                            });
                        }
                    }
                }, (err) => {
                    this.SpinnerService.closeSpinner();
                    if (err === 'STOPHOLD') {
                        this.dialog.open(RegistrationStopHoldDialog, {
                            data: { reasonCode: this.validationData.doNotProcessCode }
                        });
                    } else {
                        this.NetworkErrorService.handleNetworkError(err, true).pipe(take(1)).subscribe((resp) => {
                            if (resp === true) {
                                this.submit();
                            }
                        });
                    }
                });
        }
    }

    cancel() {
        this.property = {};
        this.router.navigateByUrl('/properties');
    }

    processMultiRelationship(propertyId: number) {
        let userId = this.userStore.getHoaHomeownerId();
        Promise.all([
            this.getPropertyGroupCandidates(userId, propertyId),
            this.getAvailableGroups(userId, propertyId)
        ]).then(() => {
            this.SpinnerService.closeSpinner();

            if(this.availableGroups.length === 0) {
                if(this.groupCandidates.length === 0) {
                    // no multiRelationship
                    this.router.navigateByUrl('/properties');
                } else {
                    // no groups available, go to create group
                    this.router.navigateByUrl('/properties/propertyGroup/create/' + propertyId,
                        { state: { propertyId: propertyId } })
                }
            } else if(this.availableGroups.length === 1 && this.groupCandidates.length === 0) {
                // one group available and no candidates to create a new group, add to existing group
                this.addToPropertyGroup(this.availableGroups[0].id, propertyId);
            } else {
                // multiple groups available and candidates exist to create new group
                this.router.navigateByUrl('/properties/propertyGroup/multiRelationShips/' + propertyId,
                    { state: { propertyId: propertyId } });
            }
        }, () => {});
    }

    getPropertyGroupCandidates(userId: number, propertyId: number): Promise<void> {
        return new Promise((resolve, reject) => {
            this.propertyGroupApi.getPropertyGroupCandidates(userId, propertyId)
                .pipe(take(1)).subscribe((resp) => {
                    this.groupCandidates = resp;
                    resolve();
                }, (err) => {
                    this.NetworkErrorService.handleNetworkError(err, true)
                        .pipe(take(1)).subscribe((resp) => {
                            if (resp === true) {
                                this.getPropertyGroupCandidates(userId, propertyId).then(() => {}, () => {});
                            } else {
                                reject();
                            }
                        });
                });
        });
    }

    getAvailableGroups(userId: number, propertyId: number): Promise<void> {
        return new Promise((resolve, reject) => {
            this.propertyGroupApi.getAvailableGroups(userId, propertyId)
                .pipe(take(1)).subscribe((resp) => {
                    this.availableGroups = resp;
                    resolve();
                }, (err) => {
                    this.NetworkErrorService.handleNetworkError(err, true)
                        .pipe(take(1)).subscribe((resp) => {
                            if (resp === true) {
                                this.getAvailableGroups(userId, propertyId).then(() => {}, () => {});
                            } else {
                                reject();
                            }
                        });
                });
        });
    }

    addToPropertyGroup(propertyGroupId: number, propertyId: number) {
        this.SpinnerService.showSpinner();
        const propertyIds: number[] = [propertyId];
        this.propertyGroupApi.propertyGroupAddProperties(propertyGroupId, propertyIds)
            .pipe(take(1)).subscribe(() => {
                this.SpinnerService.closeSpinner();
                this.router.navigateByUrl('/properties/propertyGroup/' + propertyGroupId,
                    { state: { propertyGroupId: propertyGroupId } })
            }, (err) =>{
                let dialog = this.dialog.open(DialogErrorDialog);
                dialog.afterClosed().pipe(take(1)).subscribe(() => {
                    this.SpinnerService.closeSpinner();
                    this.NetworkErrorService.handleNetworkError(err, true)
                        .pipe(take(1)).subscribe((resp) => {
                            if (resp === true) {
                                this.addToPropertyGroup(propertyGroupId, propertyId);
                            } else {
                                this.router.navigateByUrl('/properties');
                            }
                        });
                })
            });
    }
}
